import { SPEECH_CRAFT_MFE } from 'constant';
// @ts-ignore
import { getConfig } from '@edx/frontend-platform';


const PLATFORM_NAME = () => getConfig().PLATFORM_NAME;

export const useIsSpeechCraftMFE = (): any => {
  return PLATFORM_NAME() === SPEECH_CRAFT_MFE;
};
